import { createSelector } from 'reselect';

import shipmentsSelectors from 'state/shipments/selectors';
import orderSelectors from 'state/order/selectors';
import insuranceSelectors from 'state/direct-order-recurring/insurance/selectors';

import {
  validators as dateAndTimeValidators,
  methods as dateAndTimeMethods,
  constants as dateAndTimeConstants,
} from 'utils/dateAndTimes';

import { methods as addressesMethods } from 'utils/addresses';

import { getExternalProps } from 'utils/selectors';
import { isEmpty } from 'utils/types';

const getMinAndMaxForTimes = createSelector(
  shipmentsSelectors.getShipmentTimes,
  getExternalProps.order,
  orderSelectors.getTimeWindowByShipmentKey,
  (shipmentTimes, { stopType, timeParam }, timeWindow) => ({
    minMax: dateAndTimeValidators.getRulesWithRestrictions({
      times: shipmentTimes,
      isForSuggestions: { dates: false, times: true },
      timeWindow,
    })[`${stopType}_${timeParam}`],
    date: shipmentTimes[`${stopType}_date_from`],
  })
);

const getInsuredQuantity = createSelector(
  insuranceSelectors.getInsuredQuantity,
  (insuredQuantity) => insuredQuantity
);

const getOrderOfShipments = (state) => {
  const { directOrderRecurring } = state;
  const shipmentsKeysInForm = directOrderRecurring.data.shipments;

  const shipmentsOrder = [
    [shipmentsKeysInForm[0], dateAndTimeConstants.STOP_TYPES.PICKUP],
    [shipmentsKeysInForm[0], dateAndTimeConstants.STOP_TYPES.DROPOFF],
  ];
  return shipmentsOrder;
};

const getStop = ({ shipment, type }) => {
  const typeKey = type === 'pickup' ? 'from' : 'to';

  return {
    shipmentKey: shipment.shipmentKey,
    key: `${shipment.shipmentKey}.${type}`,
    stop_type: type,
    address: { ...shipment[`address_${typeKey}`] },
    time_from: dateAndTimeMethods.joinTimeAndDate(
      shipment[`${type}_time_from`],
      shipment[`${type}_date_from`],
      addressesMethods.getTimezoneOfAddress(
        shipment[addressesMethods.getAddressFromStopKey(type)]
      )
    ),
    time_to: dateAndTimeMethods.joinTimeAndDate(
      shipment[`${type}_time_to`],
      shipment[`${type}_date_to`],
      addressesMethods.getTimezoneOfAddress(
        shipment[addressesMethods.getAddressFromStopKey(type)]
      )
    ),

    loads: [...shipment.loads],
  };
};

const getStops = ({ shipments }) => {
  const shipment = shipments[0] || false;
  let firstStop = {};
  let lastStop = {};

  if (!isEmpty(shipment)) {
    firstStop = {
      ...getStop({ shipment, type: 'pickup' }),
    };
    lastStop = {
      ...getStop({ shipment, type: 'dropoff' }),
    };
  }

  return [firstStop, lastStop];
};

export default {
  getMinAndMaxForTimes,

  getOrderOfShipments,

  getStops,

  getInsuredQuantity,
};
